import { render } from "./CxResetButton.vue?vue&type=template&id=a5a8fd46"
import script from "./CxResetButton.vue?vue&type=script&lang=js"
export * from "./CxResetButton.vue?vue&type=script&lang=js"

import "./CxResetButton.vue?vue&type=style&index=0&id=a5a8fd46&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__